import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Header } from "../../components/Header";

export const Route = createFileRoute("/app")({
  beforeLoad: async ({ context: { sessionData } }) => {
    if (sessionData === null) {
      throw redirect({ to: "/login", replace: true, statusCode: 307 });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <div className="flex flex-col w-full">
      <div className="mx-auto w-full max-w-[1280px] pt-4 pl-4 pr-4 pb-0">
        <Header />
      </div>
      <Outlet />
    </div>
  );
}
